function debounce(func, ms, now) { // объявляем функцию debounce
    let onLast; // переменная отвечает за вызов функции func после того, как прошло время ожидания ms от последнего события прокрутки

    return function() { // эта функция запускается при каждом событии прокрутки
        const context = this; // запоминаем, что выполнять необходимо передаваемую функцию func
        const args = arguments; // запоминаем параметры передаваемые в функцию func

        const onFirst = now && !onLast; // если хотим запустить функцию func при первом событии прокрутки и время ожидания не установлено

        clearTimeout(onLast); // сбрасываем время ожидания ms

        onLast = setTimeout(() => { // устанавливаем время ожидания
            onLast = null; // очищаем переменную onLast
            if (!now) func.apply(context, args); // если при первом событии прокрутки функция func не была вызвана, то вызываем ее когда время ожидания ms закончилось
        }, ms); // подставляем значение параметра ms

        if (onFirst) func.apply(context, args); // запускаем функцию func при первом событии прокрутки
    }

}

export function fixHeader(){
    let header = document.querySelector('.header')
    let scrolled = window.pageYOffset
    let headerAnchor = document.getElementById('top-anchor')
    let mainSection = document.querySelector('.main')
    let scrollingTime = 200
    let scrollFromTop = 400
    window.addEventListener('scroll',function(){
        scrolled = window.pageYOffset
        // console.log(scrolled)
        // if( scrolled > 400 && header.classList.contains('header_fixed')){
        //     document.addEventListener('scroll', debounce(startScroll, scrollingTime, true));
        //     document.addEventListener('scroll', debounce(endScroll, scrollingTime));
        // }
    })
    if(scrolled >= scrollFromTop ){
        header.classList.add('header_fixed')
        // headerAnchor.style.paddingBottom = `${header.offsetHeight}px`
        if(window.innerWidth >=1000){
            mainSection.style.paddingTop = `290px`
        }
    }else {
        header.classList.remove('header_fixed')

        if(window.innerWidth >=1000) {
            mainSection.removeAttribute('style')
        }
    }

    // const startScroll = e => {
    //     // console.log('startScroll');
    //     if( scrolled > scrollFromTop && header.classList.contains('header_fixed')){
    //         header.style.opacity='0'
    //     }else {
    //         header.style.opacity='1'
    //     }
    // }
    //
    // const endScroll = e => {
    //     // console.log('endScroll');
    //     if( scrolled > scrollFromTop && header.classList.contains('header_fixed')){
    //         header.style.opacity='1'
    //
    //     }
    // }

}